export default __webpack_public_path__ + "static/media/product21.58092d36.png";